module.exports = __webpack_public_path__ + "img/e315eab.png";